(function () {
    'use strict';

    angular
        .module('controlModule')
        .controller('grcControlAssessmentFullController', Controller);

    Controller.$inject = ['$scope', '$mdToast', 'grcControlService', 'commonAricService', 'grcGovernanceProcessService'];

    function Controller($scope, $mdToast, grcControlService, commonAricService, grcGovernanceProcessService) {

        // Get Control Lookups
        grcControlService.getAllLookups()
            .then(function (lookups) {
                $scope.controlLookups = lookups;
            });

        // Get AuditMandate
        grcGovernanceProcessService.getAuditMandateProcesses()
            .then(function (mandates) {
                $scope.separateMandateProcesses = mandates;
            });

        // Get Previous Assessments
        if (!_.isUndefined($scope.boxContext) && $scope.boxContext.WithHistory) {

            commonAricService
                .getAssessmentsByControlId($scope.boxContext.Control.ControlID)
                .then(function (assessments) {
                    $scope.previousAssessments = _.filter(assessments, {
                        Assessment: {
                            GovernanceProcess: { IsActive: false }
                        }
                    });
                });
        }

        // Results
	    $scope.results = [{
	    	model: 'IsKeyControl',
	    	templateUrl: require('./grcControlAssessment.full.IsKeyControl.tpl.html')
	    }, {
	    	model: 'IsAntiFraudControl',
	    	showOn: [
			    {
				    model: 'IsKeyControl',
				    value: false
			    }
	    	],
	    	templateUrl: require('./grcControlAssessment.full.IsAntiFraudControl.tpl.html')
	    }, {
	    	model: 'MustTestForExternalAuditor',
		    showOn: [
			    {
				    model: 'IsKeyControl',
				    value: true
			    },
			    {
			    	model: 'HasBeenTestedOperationallyInPastTwoYears',
				    value: true
			    }
		    ],
            templateUrl: require('./grcControlAssessment.full.MustTestForExternal.tpl.html'),
        }, {
            model: 'ControlIsTestedInASeparateMandate',
            askQuestion: true,
            editOn: true,
            hideFollowingOn: true,
            editView: 'isEditingSeparateMandate',
            relatedModels: ['TestedInSeparateMandateID', 'SeparateMandateOperationalEffectivenessID'],
            templateUrl: require('./grcControlAssessment.full.TestedInSeparateMandate.tpl.html'),
        }, {
		    model: 'HasBeenTestedOperationallyInPastTwoYears',
		    showOn: [
			    {
				    model: 'IsKeyControl',
				    value: true
			    }
		    ],
		    templateUrl: require('./grcControlAssessment.full.TestedInPastTwoYears.tpl.html'),
	    }, {
	    	model: 'HasBeenTestedImplementationInPastTwoYears',
	        showOn: [
		        {
			        model: 'IsAntiFraudControl',
			        value: true
		        },
		        {
			        model: 'IsKeyControl',
			        value: false
		        }
	        ],
	        templateUrl: require('./grcControlAssessment.full.TestedImplementationInPastTwoYears.tpl.html'),
        }, {
            model: 'HasMajorSystemOrOperationalChanges',
            askQuestion: true,
            hideFollowingOn: true,
            templateUrl: require('./grcControlAssessment.full.MajorOperationalChanges.tpl.html'),
        }, {
            model: 'RelatedRCSARisksAssessment',
            templateUrl: require('./grcControlAssessment.full.RelatedRiskCoveredInRCSA.tpl.html'),
        }, {
            model: 'LastFYAuditResultComputedID',
            editView: 'isEditingLastFYAuditResult',
            relatedModels: ['LastFYAuditResultFinalID', 'LastFYAuditResultMandateID'],
            templateUrl: require('./grcControlAssessment.full.LastFYAuditResult.tpl.html'),
        }];

        $scope.levelOfTestingResult = {
            model: 'LevelOfTestingComputedID',
            final: 'LevelOfTestingFinalID',
            editView: 'isEditingLevelOfTesting',
            templateUrl: require('./grcControlAssessment.full.StatusFooter.tpl.html'),
        };

        $scope.answerQuestion = function (result, answer) {
            if ($scope.readOnly) return;

            if (!result.askQuestion || $scope.boxModel.IsAssessed) return;

            // Reset current result and all following result related models
            var resultIdx = _.findIndex($scope.results, { model: result.model });
            _.forEach($scope.results.slice(resultIdx), function (res) {
                if (res.askQuestion) {
                    $scope.boxModel[res.model] = null;
                }

                _.forEach(res.relatedModels, function (relatedModel) {
                    $scope.boxModel[relatedModel] = null;
                });

                $scope.view[res.editView] = false;
            });
            $scope.boxModel[$scope.levelOfTestingResult.final] = null;

            $scope.boxModel[result.model] = answer;
            $scope.saveControlAssessment()
                .then(function () {

                    if (result.editOn === answer) {
                        $scope.view[result.editView] = true;
                    }
                });
        };

        $scope.toggleEditResult = function (result) {
            if (!result.editView || $scope.readOnly) return;

            $scope.view[result.editView] = !$scope.view[result.editView];
        };

        $scope.showResult = function (result) {
			if (result.showOn) {
				return _.every(result.showOn,
					function(val) {
						return $scope.boxModel[val.model] === val.value;
					});
			}

            return _.some(getResultsToShow(), { model: result.model });
        };

        // Save Control Assessment
        $scope.saveControlAssessment = function () {
            if ($scope.readOnly) return;

            return commonAricService
                .saveControlAssessment({
                    Assessment: $scope.boxModel,
                    Control: $scope.boxContext.Control
                })
                .then(function (savedControlToAssess) {
                    $scope.updateControlToAssess(savedControlToAssess);
                    $scope.pageIsNotDirty();
                });
        };

        // Submit Control Assessment
        $scope.submitControlAssessment = function () {
            if ($scope.readOnly) return;

            return commonAricService
                .submitControlAssessment({
                    Assessment: $scope.boxModel,
                    Control: $scope.boxContext.Control
                })
                .then(function (savedControlToAssess) {

                    $mdToast.show(
                         $mdToast
                             .simple()
                             .content('Pre-Assessment has been submitted')
                             .position('top right')
                             .hideDelay($scope.govNotificationDelay)
                             .action('OK')
                             .theme('primary')
                    );

                    $scope.updateControlToAssess(savedControlToAssess);

                    _.forEach($scope.results, function (res) {
                        $scope.view[res.editView] = false;
                    });
                    $scope.view[$scope.levelOfTestingResult.editView] = false;

                    $scope.pageIsNotDirty();
                });
        };

        // Show Submit action
        $scope.showSubmitAction = function () {
            if ($scope.readOnly) return false;

            if ($scope.view.isEditingLevelOfTesting) return false;

            if (!$scope.boxModel.LevelOfTestingComputedID) return false;

            if ($scope.boxModel.IsAssessed) return false;

            var haveAllQuestionsRelatedModelsBeenAnswered =
                _.chain($scope.results)
                 .every(function (res) {
                     if (!$scope.view[res.editView]) {
                         return true;
                     }

                     return _.every(res.relatedModels, function (relatedModel) {
                         return $scope.boxModel[relatedModel];
                     });
                 })
                 .value();

            if (haveAllQuestionsRelatedModelsBeenAnswered) return true;

            //return !_.isEqual($scope.boxModel, $scope.controlAssessmentBeforeSubmit);
        };

        // Show Change Computed Level Of Testing
        $scope.showChangeComputedLevelOfTesting = function () {
            if ($scope.readOnly) return false;

            if ($scope.view[$scope.levelOfTestingResult.editView]) { return false; }

            if ($scope.boxModel.IsAssessed) { return false; }

            if (!$scope.boxModel[$scope.levelOfTestingResult.final]) { return true; }

            return $scope.boxModel[$scope.levelOfTestingResult.model] ===
                        $scope.boxModel[$scope.levelOfTestingResult.final];
        };

        // Overwrite computed level of testing
        $scope.overwriteComputedLastFYAuditResult = function () {
            if ($scope.readOnly) return;

            $scope.boxModel.LastFYAuditResultFinalID = $scope.boxModel.LastFYAuditResultComputedID;
            $scope.toggleLastFYAuditFinalResultEdit();
            $scope.saveControlAssessment();
        };

        // Toggle Last FY Audit Final Result Edit
        $scope.toggleLastFYAuditFinalResultEdit = function () {
            if ($scope.readOnly) return;

            $scope.view.isEditingLastFYAuditResult = !$scope.view.isEditingLastFYAuditResult;
        };

        // Overwrite computed level of testing
        $scope.overwriteComputedLevelOftesting = function () {
            if ($scope.readOnly) return;

            $scope.boxModel.LevelOfTestingFinalID = $scope.boxModel.LevelOfTestingComputedID;
            $scope.view.isEditingLevelOfTesting = true;
        };

        // Confirm Overwrite computed level of testing
        $scope.confirmOverwriteComputedLevelOftesting = function () {
            $scope.saveControlAssessment()
                  .then(function () {
                      $scope.submitControlAssessment();
                  });
        };

        // Show final level of testing?
        $scope.showFinalLevelOfTesting = function () {
            if (_.isUndefined($scope.boxModel)) { return; }

            return $scope.boxModel.LevelOfTestingFinalID !==
                    $scope.boxModel.LevelOfTestingComputedID;
        };

        // Show Final Comment?
        $scope.showFinalComment = function () {
            if (_.isUndefined($scope.boxModel)) return;

            if (!$scope.view.isEditingLevelOfTesting &&
                $scope.boxModel.LevelOfTestingComment) {
                return true;
            }

            return false;
        };

        // Toggle Final Level of testing
        $scope.toggleEditFinalLevelOfTesting = function () {
            if ($scope.readOnly) return;

            $scope.view.isEditingLevelOfTesting = !$scope.view.isEditingLevelOfTesting;
        };

        // Save final level of testing changes
        $scope.saveFinalLevelOfTestingChanges = function () {
            if (!$scope.boxModel.LevelOfTestingComment) { return; }

            $scope
                .saveControlAssessment()
                .then(function () {
                    $scope.view.isEditingLevelOfTesting = false;
                });
        };

        // Is Gov Process Active?
        $scope.isGovProcessActive = function () {
            if (!$scope.boxModel.GovernanceProcess) return false;

            return true;
        };

        // Toggle Collapse
        $scope.toggleCollapse = function () {
            $scope.ctxtDir.showCollapsed = !$scope.ctxtDir.showCollapsed;
        };

        // Show Collapsed?
        $scope.showCollapsed = function () {
            if (!$scope.boxModel.IsAssessed) return false;

            return $scope.ctxtDir.showCollapsed;
        };

        // Show Review?
        $scope.showReview = function () {
            if ($scope.boxModel.IsReviewing) return true;
            if ($scope.boxModel.IsReviewed) return true;

            return false;
        };

        // Show Certification?
        $scope.showCertification = function () {
            if ($scope.boxModel.IsCertifying) return true;
            if ($scope.boxModel.IsCertificationToReview) return true;
            if ($scope.boxModel.IsCompleted) return true;

            return false;
        };

        // Build Previous Control Assessment
        $scope.buildPrevCtrlAssessment = function (assessment) {
            var control = _.clone($scope.boxContext.Control);
            control.ControlAssessment = assessment;

            return control;
        };

        function getResultsToShow() {
            var resultsToShow = [];

            var lastAnsweredQuestionIdx = _.findLastIndex($scope.results, function (result) {
                if (!result.askQuestion) { return; }

                return _.isBoolean($scope.boxModel[result.model]);
            });
            var firstUnansweredQuestionIdx = _.findIndex($scope.results, function (result) {
                if (!result.askQuestion) { return; }

                return !_.isBoolean($scope.boxModel[result.model]);
            });
            var lastQuestionIdx = _.findLastIndex($scope.results, function (result) {
                if (!result.askQuestion) { return; }

                return true;
            });
            var question;

            // Show All by default
            resultsToShow = $scope.results;

            // Hide Results after last question index  if needed
            if (firstUnansweredQuestionIdx === -1) {
                question = $scope.results[lastQuestionIdx];

                if (question.hideFollowingOn === $scope.boxModel[question.model]) {
                    resultsToShow = $scope.results.slice(0, lastQuestionIdx + 1);
                }

                return resultsToShow;
            }

            // Show up until first unanswered question index
            resultsToShow = $scope.results.slice(0, firstUnansweredQuestionIdx + 1);

            if (firstUnansweredQuestionIdx > lastAnsweredQuestionIdx &&
                $scope.boxModel[$scope.levelOfTestingResult.model]) {
                question = $scope.results[lastAnsweredQuestionIdx];

                if (question && question.hideFollowingOn === $scope.boxModel[question.model]) {

                    // Show up until last answered question
                    resultsToShow = $scope.results.slice(0, lastAnsweredQuestionIdx + 1);
                } else {

                    // Show up to the first un answered question
                    resultsToShow = $scope.results.slice(0, firstUnansweredQuestionIdx);
                }

            }

            return resultsToShow;
        }

    }
})();
